export default "__VITE_ASSET__Bt6yexFO__"